export default "<div class=\"test\">\n  <button (click)=\"testAlert()\">Test Alerts</button>\n</div>\n";